const apiKey = 'AIzaSyDqpE62DhZEQ4pa_iCH3MfFzLhZgYdXyHQ';

export default apiKey;



// WEBPACK FOOTER //
// ./src/uis/components/Map/constants.js